"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appTypes = exports.initialState = void 0;
const constants_1 = require("utils/constants");
const getThemeFromLocalStorage = localStorage.getItem(constants_1.localStorageKey.themeApp) === 'dark' ? 'dark' : 'light';
exports.initialState = {
    appTheme: getThemeFromLocalStorage,
    name: process.env.APP_NAME || 'Coal Chain',
    version: process.env.APP_VERSION || '',
    globalIsLoading: true,
    sidebar: {
        status: 'expand',
        selectedMenu: { menu: 'Dashboard', pathMenu: '/dashboard' },
        menu: [
            {
                menu: 'Dashboard', title: 'Dashboard', selected: true,
                path: constants_1.pathList.dashboard.path, show: true, subMenu: constants_1.subMenuList.dashboardSubMenu
            },
            {
                menu: 'Stockpile', title: 'Stockpile', selected: false,
                path: constants_1.pathList.posStockpile.path, show: true, subMenu: []
            },
            {
                menu: 'Silo', title: 'Silo', selected: false,
                path: constants_1.pathList.posSilo.path, show: true, subMenu: []
            },
            {
                menu: 'Hopper', title: 'Hopper', selected: false,
                path: constants_1.pathList.posHopper.path, show: true, subMenu: []
            },
            {
                menu: 'BG. Loading Transshipment', title: 'Barge Loading & Transshipment', selected: false,
                path: constants_1.pathList.bgLoadingAndTranshipment.path, show: true, subMenu: []
            },
            {
                menu: 'CCTV Center', title: 'CCTV Center', selected: false,
                path: constants_1.pathList.cctv.path, show: true, subMenu: []
            },
            {
                menu: 'Daily Summary', title: 'Summary', selected: false,
                path: constants_1.pathList.dailySummary.path, show: true, subMenu: constants_1.subMenuList.dailySummarySubMenu
            },
            {
                menu: 'User Access', title: 'User Access', selected: false,
                path: constants_1.pathList.userAccess.path, show: true, subMenu: constants_1.subMenuList.userAccessSubMenu
            },
            {
                menu: 'Adjustment', title: 'Adjustment', selected: false,
                path: constants_1.pathList.adjustment.path, show: true, subMenu: constants_1.subMenuList.adjustmentSubMenu
            },
            {
                menu: 'Master Data', title: 'Master Data', selected: false,
                path: constants_1.pathList.masterData.path, show: true, subMenu: constants_1.subMenuList.masterDataSubMenu
            },
            {
                menu: 'Configuration', title: 'Configuration', selected: false,
                path: constants_1.pathList.configuration.path, show: true, subMenu: constants_1.subMenuList.configurationSubMenu
            },
            {
                menu: 'Report', title: 'Report', selected: false,
                path: constants_1.pathList.report.path, show: true, subMenu: constants_1.subMenuList.reportSubMenu
            },
            {
                menu: 'Coal Chain Simulation', title: 'Coal Chain Sim. Report', selected: false,
                path: constants_1.pathList.coalChainSimulationReport.path, show: true, subMenu: []
            },
        ]
    }
};
exports.appTypes = {
    APP_SELECT_MENU: 'APP TYPES SET SIDEBAR STATUS',
    SWITCH_APP_THEME: 'APP SWITCH THEME',
    TOGGLE_SIDEBAR: 'APP TYPES TOGGLE SIDEBAR',
    RESET_LOADING: 'APP TYPES RESET LOADING',
};
